module.exports = __webpack_public_path__ + "img/estatus_mal.259bfe5d.png";